export default __webpack_public_path__ + "static/media/moon.24acb2c2.svg";